import className from "classnames/bind";
import style from "../style/PageSpeed.module.scss";

const cn = className.bind(style);

const MOBILE = '#4f46e5';
const DESKTOP = '#0ea5e9';

/**
 * Biểu đồ xu hướng điểm Hiệu suất (0–100) của MỘT URL qua các lần đo (SVG thuần).
 * 2 đường: mobile + desktop. Điểm cao ở trên (thang cố định 0–100).
 * points: [{created, mobile, desktop}] đã sắp theo thời gian tăng dần.
 */
function PsiTrendChart({points = []}) {

	if (points.length < 2) {
		return <p style={{color: '#6b7280', fontSize: 13}}>Cần ít nhất 2 lần đo cho URL này để vẽ xu hướng.</p>;
	}

	const W = 640;
	const H = 220;
	const P = 30;
	const innerW = W - P * 2;
	const innerH = H - P * 2;

	const n = points.length;
	const x = (i) => P + (innerW * i) / (n - 1);
	const y = (score) => P + innerH - (innerH * Math.max(0, Math.min(100, score || 0))) / 100;

	const line = (key) => 'M ' + points.map((p, i) => `${x(i)},${y(p[key])}`).join(' L ');

	const ticks = [0, Math.floor((n - 1) / 2), n - 1];

	return (
		<div>
			<div style={{display: 'flex', gap: 16, marginBottom: 8, fontSize: 13}}>
				<span><span style={{display: 'inline-block', width: 10, height: 10, borderRadius: 2, background: MOBILE, marginRight: 6}} /> Mobile</span>
				<span><span style={{display: 'inline-block', width: 10, height: 10, borderRadius: 2, background: DESKTOP, marginRight: 6}} /> Desktop</span>
			</div>
			<svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" className={cn('trend-svg')} style={{width: '100%', height: 220}}>
				{/* Lưới + nhãn ngưỡng 50/90 */}
				{[0, 50, 90, 100].map((g) => (
					<g key={g}>
						<line x1={P} y1={y(g)} x2={W - P} y2={y(g)} stroke={g === 90 ? '#d1fae5' : g === 50 ? '#fef3c7' : '#eef0f4'} strokeWidth="1" vectorEffect="non-scaling-stroke" />
						<text x={4} y={y(g) + 3} fontSize="9" fill="#9ca3af">{g}</text>
					</g>
				))}

				<path d={line('desktop')} fill="none" stroke={DESKTOP} strokeWidth="2" strokeLinejoin="round" vectorEffect="non-scaling-stroke" opacity="0.9" />
				<path d={line('mobile')} fill="none" stroke={MOBILE} strokeWidth="2.5" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />

				{points.map((p, i) => (
					<g key={i}>
						<circle cx={x(i)} cy={y(p.desktop)} r="2.5" fill="#fff" stroke={DESKTOP} strokeWidth="2" vectorEffect="non-scaling-stroke" />
						<circle cx={x(i)} cy={y(p.mobile)} r="3" fill="#fff" stroke={MOBILE} strokeWidth="2" vectorEffect="non-scaling-stroke" />
					</g>
				))}

				{ticks.map((i) => (
					<text key={i} x={x(i)} y={H - 6} fontSize="9" fill="#9ca3af"
						textAnchor={i === 0 ? 'start' : i === n - 1 ? 'end' : 'middle'}>
						{String(points[i].created || '').slice(5, 10)}
					</text>
				))}
			</svg>
		</div>
	);
}

export default PsiTrendChart;
